import React from "react";

import "./iconField.sass";

interface IIconFieldProps {
    icon: React.ReactNode;
}

const IconField: React.FC<IIconFieldProps> = ({
    icon,
    children
}) => {
    return <div className="icon-field">
        {icon}
        <span className="icon-field-span">
            {children}
        </span>
    </div>;
};

export default IconField;
